import React from 'react';
import { Button, Card, CardBody, Table, Badge } from 'reactstrap';

import AddressHelper from '@src/components/Elements/AddressHelper/AddressHelper';

export default props => {
  console.log(props.entity);
  return (
    <Card className={'h-100'}>
      <CardBody>
        <div className={'font-md color-blue'}>
          <span className={'text-capitalize'}>Billing & Delivery Options</span>
          &nbsp;&nbsp;
          <Button color={'link'} onClick={props.toggleModal}>
            Edit
          </Button>
        </div>
        <div className={'pt-2 content'}>
          <Table borderless size={'sm'}>
            <tbody>
              <tr>
                <th>Chargeable</th>
                <td>{props.entity.chargeable === 0 ? 'NO' : 'YES'}</td>
              </tr>
              <tr>
                <th>Delivery Email</th>
                <td>{props.entity.delivery_email}</td>
              </tr>
              {props.entity.chargeable === 1 && (
                <React.Fragment>
                  <tr>
                    <th>Billing Email</th>
                    <td>{props.entity.invoice_email.split(',').join(', ')}</td>
                  </tr>
                  <tr>
                    <th>Billing Email CC</th>
                    <td>{props.entity.email_cc}</td>
                  </tr>
                  <tr>
                    <th className={'text-nowrap'}>Billing Email BCC</th>
                    <td>{props.entity.email_bcc}</td>
                  </tr>
                </React.Fragment>
              )}
              {props.entity.fax_number !== null &&
                props.entity.fax_number.length > 0 && (
                  <tr>
                    <th>Fax</th>
                    <td>{props.entity.fax_number}</td>
                  </tr>
                )}
              {props.entity.chargeable === 1 && (
                <tr>
                  <th>Billing Address</th>
                  <td>
                    <AddressHelper
                      address_line_1={
                        props.entity.evidence_of_insurance_form
                          .billing_address_line_1
                      }
                      address_line_2={
                        props.entity.evidence_of_insurance_form
                          .billing_address_line_2
                      }
                      city={
                        props.entity.evidence_of_insurance_form
                          .billing_address_city
                      }
                      state={
                        props.entity.evidence_of_insurance_form
                          .billing_address_state
                      }
                      zip_code={
                        props.entity.evidence_of_insurance_form
                          .billing_address_postal_code
                      }
                    />
                  </td>
                </tr>
              )}
              {props.entity.chargeable === 1 && (
                <React.Fragment>
                  <tr>
                    <th>EOI Fee</th>
                    <td>
                      {props.entity.evidence_of_insurance_pricing !== null && (
                        <React.Fragment>
                          ${props.entity.evidence_of_insurance_pricing.rate} (
                          {props.entity.evidence_of_insurance_pricing.item_name}
                          )
                        </React.Fragment>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>Pre-Pay</th>
                    <td>
                      {props.entity.pre_pay === 1 ? (
                        <Badge color={'danger'}>REQUIRED</Badge>
                      ) : (
                        'Not Required'
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>Invoice</th>
                    <td>
                      {props.entity.qb_invoice_id !== null ? (
                        props.entity.qb_invoice_removed ? (
                          <React.Fragment>
                            <span style={{ color: '#721c24' }}>
                              Invoice link is no longer valid.
                            </span>
                            <br />
                            <Button
                              color={'link'}
                              className={'p-0 m-0'}
                              onClick={props.createInvoice}
                              disabled={
                                props.entity.invoice_email.length === 0 ||
                                props.entity.association === null ||
                                props.entity.unit === null ||
                                props.entity.evidence_of_insurance_pricing ===
                                null ||
                                props.entity.approved !== 1
                              }
                            >
                              Click Here to Create Invoice
                            </Button>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <a
                              href={props.entity.qb_invoice_link}
                              className={'p-0 m-0'}
                              target={'_blank'}
                            >
                              View Invoice #{props.entity.qb_invoice_number}
                              &nbsp;
                              {props.entity.qb_invoice_paid ? (
                                <Badge color={'success'}>PAID</Badge>
                              ) : (
                                <Badge color={'danger'}>UNPAID</Badge>
                              )}
                            </a>
                            <br />
                            <Button
                              color={'link'}
                              className={'p-0 m-0'}
                              style={{
                                fontSize: '14px',
                                textDecoration: 'none'
                              }}
                              onClick={props.sendQBInvoice}
                            >
                              Email Invoice
                            </Button>
                            &nbsp;
                            {props.entity.qb_invoice_sent ? (
                              <Badge color={'success'}>SENT</Badge>
                            ) : (
                              <Badge color={'danger'}>UNSENT</Badge>
                            )}
                          </React.Fragment>
                        )
                      ) : (
                        <Button
                          color={'link'}
                          className={'p-0 m-0'}
                          onClick={props.createInvoice}
                          disabled={
                            props.entity.invoice_email.length === 0 ||
                            props.entity.association === null ||
                            props.entity.unit === null ||
                            props.entity.evidence_of_insurance_pricing ===
                              null ||
                            props.entity.approved !== 1
                          }
                        >
                          Click Here to Create Invoice
                        </Button>
                      )}
                    </td>
                  </tr>
                </React.Fragment>
              )}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  );
};
